(() => {
  if (!customElements.get("cereblue-delivery"))
    customElements.define(
      "cereblue-delivery",
      class extends HTMLElement {
        connectedCallback() {
          const parts = new Intl.DateTimeFormat("en-GB", {
            timeZone: "Europe/London",
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            hourCycle: "h23",
          }).formatToParts(new Date());
          const values = Object.fromEntries(
            parts.map((part) => [part.type, part.value]),
          );
          const delivery = new Date(
            Date.UTC(
              Number(values.year),
              Number(values.month) - 1,
              Number(values.day),
              12,
            ),
          );
          const advance = () => {
            do {
              delivery.setUTCDate(delivery.getUTCDate() + 1);
            } while ([0, 6].includes(delivery.getUTCDay()));
          };
          // Owner-confirmed weekday dispatch before 13:00 UK time; Standard transit is 2–4 business days.
          if (
            [0, 6].includes(delivery.getUTCDay()) ||
            Number(values.hour) >= 13
          )
            advance();
          for (let day = 0; day < 4; day++) advance();
          this.querySelector("[data-delivery-date]").textContent =
            `Get it by ${new Intl.DateTimeFormat("en-GB", { timeZone: "UTC", weekday: "long", day: "numeric", month: "short" }).format(delivery)}`;
        }
      },
    );
  if (!customElements.get("cereblue-research"))
    customElements.define(
      "cereblue-research",
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.abort = new AbortController();
          const signal = this.abort.signal;
          this.tabs = [...this.querySelectorAll("[data-research-tab]")];
          this.panels = [...this.querySelectorAll("[data-research-panel]")];
          if (!this.tabs.length || this.tabs.length !== this.panels.length)
            return;
          this.querySelector('[role="tablist"]').hidden = false;
          this.classList.add("is-enhanced");
          this.tabs.forEach((tab, index) => {
            tab.addEventListener("click", () => this.select(index), { signal });
            tab.addEventListener(
              "keydown",
              (event) => {
                const keys = ["ArrowRight", "ArrowLeft", "Home", "End"];
                if (!keys.includes(event.key)) return;
                event.preventDefault();
                let next =
                  event.key === "Home"
                    ? 0
                    : event.key === "End"
                      ? this.tabs.length - 1
                      : (index +
                          (event.key === "ArrowRight" ? 1 : -1) +
                          this.tabs.length) %
                        this.tabs.length;
                this.select(next);
                this.tabs[next].focus();
              },
              { signal },
            );
          });
          document.addEventListener(
            "shopify:block:select",
            (event) => {
              const index = this.panels.findIndex(
                (panel) => panel.dataset.blockId === event.detail?.blockId,
              );
              if (index >= 0) this.select(index);
            },
            { signal },
          );
          this.select(0);
        }
        select(index) {
          this.tabs.forEach((tab, i) => {
            tab.setAttribute("aria-selected", String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            this.panels[i].hidden = i !== index;
          });
        }
        disconnectedCallback() {
          this.abort?.abort();
        }
      },
    );
  if (!customElements.get("cereblue-quotes"))
    customElements.define(
      "cereblue-quotes",
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.abort = new AbortController();
          const signal = this.abort.signal;
          const track = this.querySelector(".cb-quotes__track"),
            items = [...track.children];
          this.querySelector(".cb-quotes__controls").hidden = false;
          const current = () =>
            Math.max(
              0,
              Math.min(
                items.length - 1,
                Math.round(track.scrollLeft / track.clientWidth),
              ),
            );
          const update = () => {
            const i = current();
            this.querySelector("[data-quote-count]").textContent =
              `${String(i + 1).padStart(2, "0")} / ${String(items.length).padStart(2, "0")}`;
            this.querySelector("[data-prev]").disabled = i === 0;
            this.querySelector("[data-next]").disabled = i === items.length - 1;
          };
          this.querySelector("[data-prev]").addEventListener(
            "click",
            () => move(-1),
            { signal },
          );
          this.querySelector("[data-next]").addEventListener(
            "click",
            () => move(1),
            { signal },
          );
          const move = (direction) =>
            track.scrollTo({
              left:
                Math.max(0, Math.min(items.length - 1, current() + direction)) *
                track.clientWidth,
              behavior: matchMedia("(prefers-reduced-motion: reduce)").matches
                ? "instant"
                : "smooth",
            });
          track.addEventListener("scroll", update, { signal, passive: true });
          update();
        }
        disconnectedCallback() {
          this.abort?.abort();
        }
      },
    );
})();
